import { createContext, useContext, useState, useEffect } from 'react';
import { templateAPI } from '../lib/api';

const AppSettingsContext = createContext({ app_name: 'Plaster Survey', logo_base64: '' });

export const useAppSettings = () => useContext(AppSettingsContext);

export const AppSettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState(() => {
        try {
            const cached = localStorage.getItem('app_settings');
            return cached ? JSON.parse(cached) : { app_name: 'Plaster Survey', logo_base64: '' };
        } catch {
            return { app_name: 'Plaster Survey', logo_base64: '' };
        }
    });

    const refresh = async () => {
        try {
            const res = await templateAPI.get();
            const s = {
                app_name: res.data.app_name || 'Plaster Survey',
                logo_base64: res.data.logo_base64 || ''
            };
            setSettings(s);
            localStorage.setItem('app_settings', JSON.stringify(s));
        } catch {}
    };

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) refresh();
    }, []);

    return (
        <AppSettingsContext.Provider value={{ ...settings, refresh }}>
            {children}
        </AppSettingsContext.Provider>
    );
};
